import React from 'react';
import HoaFee from '../HoaFee/HoaFee';
import LotSizeRange from '../LotSizeRange/LotSizeRange';
import ParkingSpot from '../ParkingSpot/ParkingSpot';
import YearBuiltRange from '../YearBuilt/YearBuiltRange';

const PropertyDetailsFilter = () => {

	return (
		<>
			<h2 className=''>Property Details</h2>
			<YearBuiltRange />
			<LotSizeRange />
			<HoaFee />
			<ParkingSpot />
		</>
	);
};

export default PropertyDetailsFilter;
